import { InputLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Theme, useTheme } from "@mui/material/styles";
import * as React from "react";
import { properlizeWords } from "../../helpers";

const ITEM_HEIGHT = 60;
const ITEM_PADDING_TOP = 16;
const MenuProps = {
  style: {
    zIndex: 5000000000,
  },
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

interface ICustomMultipleSelect {
  placeHolder: string;
  id: string;
  onBlur?: {
    (e: React.FocusEvent<any, Element>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  options: string[];
  value: string[];
  error?: boolean;
  setValue: (val: string[]) => void;
  onFieldChange: () => void;
  fullWidth?: boolean;
}

const CustomMultipleSelect: React.FC<ICustomMultipleSelect> = ({
  id,
  placeHolder,
  onBlur,
  error,
  options,
  value,
  setValue,
  onFieldChange,
  fullWidth,
}) => {
  const theme = useTheme();

  const ref = React.useRef();
  const [showSelect, setShowSelect] = React.useState(false);

  const handleChange = (event: SelectChangeEvent<typeof value>) => {
    const { target } = event;
    setValue(
      // On autofill we get a stringified value.
      typeof target.value === "string" ? target.value.split(",") : target.value,
    );

    setShowSelect(false);
  };

  return (
    <FormControl sx={{ m: 1, width: 300 }}>
      <InputLabel
        id="demo-multiple-name-label"
        sx={{
          color: `${theme.palette.primary.main} !important`,
          fontFamily: "Inter !important",
          ml: "-.25rem",
        }}
      >
        {placeHolder}
      </InputLabel>
      <Select
        fullWidth={fullWidth ? true : false}
        sx={{
          height: "3rem",
        }}
        labelId="demo-multiple-name-label"
        id={id}
        error={error}
        multiple
        ref={ref}
        open={showSelect}
        onOpen={() => setShowSelect(true)}
        onClose={() => setShowSelect(false)}
        value={value}
        onBlur={onBlur}
        onChange={(e) => {
          handleChange(e);
          onFieldChange();
        }}
        input={<OutlinedInput label="Name" />}
        MenuProps={MenuProps}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            style={getStyles(option, value, theme)}
          >
            {properlizeWords(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomMultipleSelect;
